<!-- @format -->
@if (mediaCount > 0) {
	<div class="hmf-display-flex">
		<span class="label-disabled hmf-mr-xxs">|</span>
		<button
			hmf-action-text
			variant="group"
			startIconName="photo-images-filled"
			class="hmf-flex"
			[attr.aria-label]="'Review Images: ' + mediaCount"
			(click)="handleClick()">
			({{ mediaCount }})
		</button>
	</div>
}